/**
 * May a prepay order be staffed and worked? (Marti 2026-10-03.)
 *
 * Work never starts before the whole prepayment has arrived — unless the admin
 * decides to start by agreement with the client. Both are admin decisions on
 * the order: marking the proforma paid, or recording the agreement
 * (`prepaymentWaiver`). Every gate that used to ask "is it paid?" asks this,
 * on the server and in the apps alike.
 */
import type { Job } from './job';

export type PrepayGateJob = {
  payment?: { mode?: string } | null;
  paymentStatus?: string | null;
  prepaymentWaiver?: Job['prepaymentWaiver'] | null;
};

export function prepayCleared(job: PrepayGateJob): boolean {
  return job.payment?.mode !== 'prepay' || job.paymentStatus === 'paid' || !!job.prepaymentWaiver;
}

/** Order parts that can no longer take a prepayment. */
const PREPAY_CLOSED = ['cancelled', 'invoiced', 'completed'];

export type PrepayPartJob = {
  status: string;
  payment?: { mode?: string } | null;
  pricing?: unknown;
};

/**
 * PB-11 (Marti 2026-10-28) — the live prepay parts of an order that have no
 * price. The order's one proforma cannot cover them, so none is issued until
 * the admin prices them; and the payment deadline does not cancel an order
 * whose client was never billed. They used to be left off the proforma
 * silently and cancelled alone at their deadline.
 */
export function unpricedPrepayParts<T extends PrepayPartJob>(jobs: T[]): T[] {
  return jobs.filter(
    (j) => j.payment?.mode === 'prepay' && !PREPAY_CLOSED.includes(j.status) && !j.pricing,
  );
}
